"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Type = exports.Line = exports.Label = exports.Colon = void 0;
exports.ValueView = ValueView;
exports.getValueString = getValueString;
exports.typeMap = exports.isFloat = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread2"));
var _react = require("react");
var _node = require("./node");
var _meta = require("./comps/meta");
var _copied = require("./copied");
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["children", "style"],
  _excluded2 = ["value", "setValue", "data", "keyName", "indentWidth", "renderKey", "quotes", "level", "renderValue", "renderBraces", "enableClipboard", "displayObjectSize", "displayDataTypes"],
  _excluded3 = ["children", "color", "fontSize", "opacity", "paddingRight", "style"];
var Line = function Line(props) {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", (0, _objectSpread2["default"])({}, props));
};
exports.Line = Line;
var isFloat = function isFloat(n) {
  return Number(n) === n && n % 1 !== 0 || isNaN(n);
};
exports.isFloat = isFloat;
var typeMap = {
  string: {
    color: 'var(--w-rjv-type-string-color, #cb4b16)',
    label: 'string'
  },
  number: {
    color: 'var(--w-rjv-type-int-color, #268bd2)',
    label: 'int'
  },
  "float": {
    color: 'var(--w-rjv-type-float-color, #859900)',
    label: 'float'
  },
  bigint: {
    color: 'var(--w-rjv-type-bigint-color, #268bd2)',
    label: 'bigint'
  },
  "boolean": {
    color: 'var(--w-rjv-type-boolean-color, #2aa198)',
    label: 'bool'
  },
  date: {
    color: 'var(--w-rjv-type-date-color, #586e75)',
    label: 'date'
  },
  url: {
    color: 'var(--w-rjv-type-url-color, #0969da)',
    label: 'url'
  },
  "null": {
    color: 'var(--w-rjv-type-null-color, #d33682)',
    label: 'null'
  },
  NaN: {
    color: 'var(--w-rjv-type-nan-color, #859900)',
    label: 'NaN'
  },
  undefined: {
    color: 'var(--w-rjv-type-undefined-color, #586e75)',
    label: 'undefined'
  }
};
exports.typeMap = typeMap;
var Colon = function Colon(_ref) {
  var _ref$children = _ref.children,
    children = _ref$children === void 0 ? ':' : _ref$children,
    style = _ref.style,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("span", (0, _objectSpread2["default"])((0, _objectSpread2["default"])({
    className: "w-rjv-colon",
    style: (0, _objectSpread2["default"])({
      paddingRight: 3
    }, style)
  }, props), {}, {
    children: children
  }));
};
exports.Colon = Colon;
function getValueString(value) {
  var type = (0, _typeof2["default"])(value);
  var content = '';
  if (typeof value === 'number') {
    type = isFloat(value) ? 'float' : 'number';
    content = value.toString();
  }
  if (typeof value === 'boolean') {
    type = 'boolean';
    content = value.toString();
  }
  if ((0, _typeof2["default"])(value) === 'object' && value instanceof Date) {
    type = 'date';
    content = value.toString();
  }
  if (value === null) {
    type = 'null';
    content = "".concat(value).toLocaleUpperCase();
  }
  if (value === undefined) {
    type = 'undefined';
    content = String(value);
  }
  if (typeof value === 'bigint') {
    type = 'bigint';
    content = "".concat(value, "n");
  }
  var isURL = value instanceof URL;
  if (isURL) {
    type = 'url';
    content = "\"".concat(value.href, "\"");
  }
  if (typeof value === 'string') {
    content = "\"".concat(value, "\"");
  }
  return {
    type: type,
    content: content
  };
}
function ValueView(props) {
  var _typeMap$type;
  var value = props.value,
    setValue = props.setValue,
    data = props.data,
    keyName = props.keyName,
    indentWidth = props.indentWidth,
    renderKey = props.renderKey,
    quotes = props.quotes,
    level = props.level,
    renderValue = props.renderValue,
    renderBraces = props.renderBraces,
    enableClipboard = props.enableClipboard,
    displayObjectSize = props.displayObjectSize,
    displayDataTypes = props.displayDataTypes,
    reset = (0, _objectWithoutProperties2["default"])(props, _excluded2);
  var color = '';
  var style = {};
  var _getValueString = getValueString(value),
    type = _getValueString.type,
    content = _getValueString.content;
  var typeView = /*#__PURE__*/(0, _jsxRuntime.jsx)(Type, {
    type: type
  });
  if (value === null) {
    typeView = /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Fragment, {});
    style = {
      fontWeight: 'bold'
    };
  }
  if (value === undefined) {
    typeView = /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Fragment, {});
  }
  var isURL = value instanceof URL;
  if (!displayDataTypes) {
    typeView = /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Fragment, {});
  }
  color = ((_typeMap$type = typeMap[type]) === null || _typeMap$type === void 0 ? void 0 : _typeMap$type.color) || '';
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    showTools = _useState2[0],
    setShowTools = _useState2[1];
  var tools = enableClipboard ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_copied.Copied, {
    show: showTools,
    text: value
  }) : undefined;
  var eventProps = {
    className: 'w-rjv-line',
    style: {
      paddingLeft: indentWidth
    }
  };
  if (enableClipboard) {
    eventProps.onMouseEnter = function () {
      return setShowTools(true);
    };
    eventProps.onMouseLeave = function () {
      return setShowTools(false);
    };
  }
  if (content && typeof content === 'string') {
    var reView = renderValue && renderValue({
      className: 'w-rjv-value',
      style: (0, _objectSpread2["default"])({
        color: color
      }, style),
      type: type,
      value: value,
      setValue: setValue,
      data: data,
      quotes: quotes,
      keyName: keyName,
      visible: showTools,
      content: content,
      children: content
    });
    var valueView = reView ? reView : /*#__PURE__*/(0, _jsxRuntime.jsx)(Label, {
      color: color,
      style: style,
      className: "w-rjv-value",
      children: isURL ? /*#__PURE__*/(0, _jsxRuntime.jsx)("a", {
        href: value.href,
        style: {
          color: color
        },
        target: "_blank",
        rel: "noopener noreferrer",
        children: content
      }) : content
    });
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(Line, (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, eventProps), {}, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(Label, (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, reset), {}, {
        ref: null,
        children: [renderKey, /*#__PURE__*/(0, _jsxRuntime.jsx)(Colon, {}), typeView, valueView, tools]
      }))
    }));
  }
  var length = Array.isArray(value) ? value.length : Object.keys(value).length;
  var empty = /*#__PURE__*/(0, _jsxRuntime.jsxs)(_react.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_meta.Meta, {
      render: renderBraces,
      start: true,
      isArray: Array.isArray(value)
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_meta.Meta, {
      render: renderBraces,
      isArray: Array.isArray(value)
    }), displayObjectSize && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_node.CountInfo, {
      children: [length, " items"]
    })]
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(Line, (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, eventProps), {}, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(Label, (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, reset), {}, {
      ref: null,
      children: [renderKey, /*#__PURE__*/(0, _jsxRuntime.jsx)(Colon, {}), typeView, empty, tools]
    }))
  }));
}
var Label = /*#__PURE__*/(0, _react.forwardRef)(function (_ref2, ref) {
  var children = _ref2.children,
    color = _ref2.color,
    fontSize = _ref2.fontSize,
    opacity = _ref2.opacity,
    paddingRight = _ref2.paddingRight,
    style = _ref2.style,
    reset = (0, _objectWithoutProperties2["default"])(_ref2, _excluded3);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("span", (0, _objectSpread2["default"])((0, _objectSpread2["default"])({
    style: (0, _objectSpread2["default"])({
      color: color,
      fontSize: fontSize,
      opacity: opacity,
      paddingRight: paddingRight
    }, style)
  }, reset), {}, {
    ref: ref,
    children: children
  }));
});
exports.Label = Label;
var Type = function Type(props) {
  var _typeMap$type2, _typeMap$type3;
  var type = props.type;
  var color = (_typeMap$type2 = typeMap[type]) === null || _typeMap$type2 === void 0 ? void 0 : _typeMap$type2.color;
  var label = (_typeMap$type3 = typeMap[type]) === null || _typeMap$type3 === void 0 ? void 0 : _typeMap$type3.label;
  if (color && label) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(Label, {
      color: color,
      fontSize: 11,
      opacity: 0.8,
      paddingRight: 4,
      className: "w-rjv-type",
      "data-type": type,
      children: label
    });
  }
};
exports.Type = Type;